import React, { useState, Fragment } from "react";
import axios from "axios";
import { getData } from "app/data";
import { rootUrl } from "config/setting";
import classes from "./RequestForm.module.css";
import { logRoles } from "@testing-library/react";

const RequestForm = props => {
  const [isSubmit, setIsSubmit] = useState(false);
  const [isValidated, setIsValidated] = useState(true);
  const [isReferral, setIsReferral] = useState(false);
  const [isOther, setIsOther] = useState(false);
  const [dynamicPlaceHolder, setDynamicPlaceHolder] = useState("Type here...");

  const formSubmitHandler = async e => {
    e.preventDefault();

    const {
      name,
      email,
      company,
      phone,
      location,
      service,
      country,
      message,
      answer,
    } = e.target.elements;

    let details = {};

    if (answer === undefined) {
      details = {
        "your-name": name.value,
        "your-email": email.value,
        "your-company": company.value,
        "your-phone": phone.value,
        "your-location": location.value,
        "your-service": service.value,
        "your-country": country.value,
        "your-message": message.value,
      };
    } else {
      details = {
        "your-name": name.value,
        "your-email": email.value,
        "your-company": company.value,
        "your-phone": phone.value,
        "your-location": location.value,
        "your-service": service.value,
        "your-answer": answer.value,
        "your-country": country.value,
        "your-message": message.value,
      };
    }

    if (
      name.value !== "" &&
      email.value !== "" &&
      company.value !== "" &&
      phone.value !== ""
    ) {
      const form = new FormData();
      for (const field in details) {
        form.append(field, details[field]);
      }
      axios
        .post(
          `${rootUrl}/wp-json/contact-form-7/v1/contact-forms/${props.formId}/feedback`,
          form,
          { headers: { "content-type": "multipart/form-data" } }
        )
        .then(function (response) {
          console.log(response);
          setIsSubmit(true);
          setIsValidated(true);
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      setIsValidated(false);
    }
  };

  const showAnswerForm = value => {
    if (value === "Referral") {
      setIsReferral(true);
      setDynamicPlaceHolder("Type here...");
    } else if (value === "Other") {
      setIsOther(true);
      setDynamicPlaceHolder(props.optionalSelect);
    } else {
      setIsReferral(false);
      setIsOther(false);
    }
  };

  const showFormHandler = () => {
    setIsSubmit(false);
    setIsReferral(false);
    setIsOther(false);
  };

  return (
    <Fragment>
      {!isSubmit ? (
        <Fragment>
          <h3 className={classes["form-title"]}>
            {getData("goDigital").form.title}
          </h3>
          <div className={classes["req-form-container"]}>
            <form onSubmit={formSubmitHandler}>
              <div className={classes["req-form-input"]}>
                <h2 className={classes["req-form-title"]}>
                  {props.formHeader}
                </h2>
                <input
                  type="text"
                  placeholder="Your Name*"
                  id="name"
                  name="your-name"
                />
                <input
                  type="text"
                  placeholder="Email Address*"
                  id="email"
                  name="your-email"
                />
                <input
                  type="text"
                  placeholder="Phone Number*"
                  id="phone"
                  name="your-phone"
                />
                <input
                  type="text"
                  placeholder="Company / Business*"
                  id="company"
                  name="your-company"
                />
                <input
                  type="text"
                  placeholder="Number of Locations"
                  id="location"
                  name="your-location"
                />
                <select
                  placeholder="Country"
                  id="country"
                  name="your-country"
                  defaultValue="Canada"
                >
                  <option value="canada" key="canada">
                    {getData("requestADemoData").form.canada}
                  </option>
                  <option value="not_canada" key="not_canada">
                    {getData("requestADemoData").form.not_canada}
                  </option>
                </select>
                <select
                  placeholder={props.optionalSelect}
                  id="service"
                  name="your-service"
                  defaultValue={props.optionalSelect}
                  onChange={e => showAnswerForm(e.target.value)}
                >
                  <option
                    value={props.optionalSelect}
                    key={props.optionalSelect}
                    disabled
                  >
                    {props.optionalSelect}
                  </option>
                  {props.optionalSelectOptions.map(option => (
                    <option value={option} key={option}>
                      {option}
                    </option>
                  ))}
                </select>
                {(isReferral || isOther) && (
                  <input
                    type="text"
                    placeholder={dynamicPlaceHolder}
                    id="answer"
                    name="your-answer"
                  />
                )}
                <textarea
                  type="text"
                  placeholder="Additional comments"
                  id="message"
                  name="your-message"
                />
                <div
                  className={
                    isValidated
                      ? classes["required-valid"]
                      : classes["required-warning"]
                  }
                >
                  <span className={classes["warning"]}>
                    Please fill in all the required fields*
                  </span>
                </div>
                <button
                  id="btnFlexFix"
                  className={`${classes["custom-button"]} green-button`}
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </Fragment>
      ) : (
        <div className={classes["req-form-submitted"]}>
          <h2 className={classes["req-form-submitted-title"]}>
            {getData("goDigital").form.submitted}
          </h2>
          <p className={classes["req-form-submitted-message"]}>
            {getData("goDigital").form.submittedMessage}
          </p>
          <button
            id="btnFlexFix"
            className={`${classes["req-form-submitted-button"]} green-button`}
            onClick={showFormHandler}
          >
            {getData("goDigital").form.submittedButton}
          </button>
        </div>
      )}
    </Fragment>
  );
};

export default RequestForm;
